import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-04e86e4a")

_pushScopeId("data-v-04e86e4a")
const _hoisted_1 = { class: "consume" }
const _hoisted_2 = { class: "control-bar" }
const _hoisted_3 = { class: "search-wrap" }
const _hoisted_4 = { class: "overage" }
const _hoisted_5 = { class: "table" }
const _hoisted_6 = { style: {"color":"red"} }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_PageHeader = _resolveComponent("PageHeader")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_m_table = _resolveComponent("m-table")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("header", null, [
      _createVNode(_component_PageHeader, {
        type: "link",
        title: "消耗明细"
      })
    ]),
    _createVNode("main", null, [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_el_input, {
              placeholder: "请输入流水号",
              modelValue: _ctx.keyword,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.keyword = $event)),
              class: "input-with-select",
              size: "medium",
              style: {"width":"350px"}
            }, {
              append: _withId(() => [
                _createVNode(_component_el_button, {
                  size: "medium",
                  icon: "el-icon-search",
                  onClick: _ctx.search
                }, null, 8, ["onClick"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createVNode("div", _hoisted_4, "余额：" + _toDisplayString(_ctx.overage || '-'), 1)
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_m_table, {
            data: _ctx.tableList,
            loading: _ctx.loading,
            ref: "mTable",
            pagination: _ctx.pagination,
            onCurrentChange: _ctx.pageChange
          }, {
            default: _withId(() => [
              _createVNode(_component_el_table_column, {
                prop: "trade_no",
                label: "流水号"
              }),
              _createVNode(_component_el_table_column, {
                prop: "value",
                label: "数量"
              }),
              _createVNode(_component_el_table_column, { label: "余额" }, {
                default: _withId(({ row }) => [
                  _createVNode("span", _hoisted_6, _toDisplayString(row.sub_total), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, { label: "类型" }, {
                default: _withId(({ row }) => [
                  _createTextVNode(_toDisplayString(row.type === '1' ? '充值' : '消费'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, { label: "创建时间" }, {
                default: _withId(({ row }) => [
                  _createTextVNode(_toDisplayString(_ctx.parseTime(row.create_time, '{y}-{m}-{d} {h}:{i}:{s}')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "备注",
                width: "100"
              }, {
                default: _withId(({ row }) => [
                  _createTextVNode(_toDisplayString(row.remark || '—'), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data", "loading", "pagination", "onCurrentChange"])
        ])
      ])
    ])
  ], 64))
})